import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

export interface Week {
  id: string;
  ordinal: number;
  name: string;
  startDate: string;
  endDate: string;
  active?: boolean;
}

export interface WeekPayload {
  name?: string;
  ordinal?: number;
  startDate?: string;
  endDate?: string;
  active?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class WeeksService {
  private readonly url = ApiConstants.URL_WEEKS;

  constructor(private http: HttpClient) { }

  async list(): Promise<Week[]> {
    const response = await firstValueFrom(this.http.get<any>(this.url));
    return response.data;
  }

  async getById(id: string): Promise<Week> {
    const response = await firstValueFrom(this.http.get<any>(`${this.url}/${id}`));
    return response.data;
  }

  async create(body: WeekPayload): Promise<Week> {
    const response = await firstValueFrom(this.http.post<any>(this.url, body));
    return response.data;
  }

  async update(id: string, body: WeekPayload): Promise<Week> {
    const response = await firstValueFrom(this.http.patch<any>(`${this.url}/${id}`, body));
    return response.data;
  }
}
